import {PrintoutOrientation} from "crqlar-react-common/dist/models/printout/printout.model";

export interface PrintoutPageSize {
    pageHeight: number;
    // Content width excludes horizontal margins.
    pageWidth: number;
    marginTop: number;
    marginBottom: number;
    marginLeft: number;
    marginRight: number;
}

export interface PrintoutPaginationOptions extends PrintoutPageSize {
    pageGap: number;
    pageGapBorderColor: string;
    pageBreakBackground: string;
}

// A4 at 96 dpi; pageWidth excludes margins.
export const A4_PRINTOUT_PAGE_SIZE: PrintoutPageSize = {
    pageHeight: 1123,
    pageWidth: 698,
    marginTop: 48,
    marginBottom: 48,
    marginLeft: 48,
    marginRight: 48,
};

// Screen-only gap between pages.
export const PRINTOUT_PAGE_GAP = 36;
export const PRINTOUT_PAGE_GAP_BORDER_COLOR = "#d8dee9";
export const PRINTOUT_PAGE_BREAK_BACKGROUND = "#f3f4f6";

export const getPrintoutOverallWidth = (pageSize: PrintoutPageSize) => (
    pageSize.pageWidth + pageSize.marginLeft + pageSize.marginRight
);

// Swap overall dimensions first, then subtract the horizontal margins.
export const getPrintoutPageSize = (orientation?: PrintoutOrientation): PrintoutPageSize => {
    if (orientation !== PrintoutOrientation.LANDSCAPE) {
        return A4_PRINTOUT_PAGE_SIZE;
    }

    const portrait = A4_PRINTOUT_PAGE_SIZE;
    const overallWidth = getPrintoutOverallWidth(portrait);

    return {
        ...portrait,
        pageHeight: overallWidth,
        pageWidth: portrait.pageHeight - portrait.marginLeft - portrait.marginRight,
    };
};

export const getPrintoutPaginationOptions = (
    orientation?: PrintoutOrientation,
): PrintoutPaginationOptions => ({
    ...getPrintoutPageSize(orientation),
    pageGap: PRINTOUT_PAGE_GAP,
    pageGapBorderColor: PRINTOUT_PAGE_GAP_BORDER_COLOR,
    pageBreakBackground: PRINTOUT_PAGE_BREAK_BACKGROUND,
});

export const getPrintoutCssPageSize = (orientation?: PrintoutOrientation): string => (
    orientation === PrintoutOrientation.LANDSCAPE ? "A4 landscape" : "A4 portrait"
);

// CSS px to mm at 96 dpi.
const cssPxToMm = (px: number) => Number((px * (25.4 / 96)).toFixed(4));

export const getPrintoutCssPageMargin = (orientation?: PrintoutOrientation): string => {
    const pageSize = getPrintoutPageSize(orientation);

    return [pageSize.marginTop, pageSize.marginRight, pageSize.marginBottom, pageSize.marginLeft]
        .map((margin) => `${cssPxToMm(margin)}mm`)
        .join(" ");
};
